import React from 'react'

const Table = ({ tableData, tableHeadings }) => {
    // console.log("Leader board data ", tableData);
    return (
        <div className="relative overflow-x-auto">
            <table className="w-full  text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 pr-32">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                    <tr>
                        {tableHeadings.map((data) => {
                            return (
                                <th scope="col" className="px-6 text-center py-3 mx-auto">
                                    {data}
                                </th>
                            )
                        })}
                    </tr>
                </thead>
                <tbody>
                {tableData.map((data , key) => {
                                return (
                                        <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 mx-5">
                                                <th
                                                    scope="row"
                                                    className="text-center mx-10  py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
                                                >
                                                    {data.rank}
                                                </th>
                                                <td className="px-6 text-center  py-4">{data.userName}</td>
                                                <td className="px-6 text-center mx-10  py-4">{data.numberOfManeuvers}</td>
                                                <td className="px-6 text-center mx-10  py-4">{data.bestScore?.toFixed(2)}</td>
                                        </tr>
                                )
                            })}
                </tbody>
            </table>
        </div>

    )
}

export default Table